import styles from './ServicesSolutions.module.scss';

export type Props = {
  title: string;
  services: string[];
};

const ServicesSolutions = (props: Props): JSX.Element => {
  const { title, services } = props;
  return (
    <div className={styles.services}>
      <div className={styles.container}>
        <div className={styles.title}>
          <div className={`h5 ${styles.h5}`}>{title}</div>
        </div>
        <div className={styles.listOfServices}>
          <ol>
            {services?.map((service, id) => (
              <li key={id}>
                <div className={`text_5 ${styles.text_5}`}>
                  <span>{id + 1}</span>
                  {service}
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};
export default ServicesSolutions;
